import services from './services';
import {
    lg,
    cloneDeep,
    util,
    isCorrectVal,
    isDate
} from 'utils';
import {
    GetProvinces,
    GetCitys,
    GetAreas,
    GetAgentList,
    GetParmConfig, //寄送，支付接口
    GetProductClass,
    GetAgentConsigneeList,
    Consignee_Add,
    GetEmployList,
    ConsigneeSetDefault
} from '@api/commonApi.js';
import NProgress from 'nprogress';
import $http from '$http';
import chooseDialog from "@pages/Order/MeetOrder/components/chooseDialog/index.vue" //选择代理商、园所弹窗
import AddressDialog from "@pages/Order/MeetOrder/components/AddressDialog/index.vue" // 选择收货地址弹窗
import optOpenClassDialog from '@pages/Order/components/optOpenClassDialog/index.vue'; //添加幼儿园（原开课申请）
import payTypeInfo from '@pages/Order/MeetOrder/components/payTypes/index.vue'; //支付方式
import addAgent from 'components/agent-add/index.vue'; //新增代理商
export default {
    mixins: [services],
    components: {
        chooseDialog,
        AddressDialog,
        optOpenClassDialog,
        payTypeInfo,
        addAgent
    },
    props: {
        value: {
            type: Boolean,
            default: null
        },
    },
    created() {
        this.getPay(8);
        this.getPay(9);

    },
    data() {
        return {
            num: 1,
            step: 1, //步数 
            loading: false,
            UnitPrice: 19800, //默认D套餐
            ExperienceClassNum: 5, //体验课数
            agent: '',
            school: '',
            // options: [
            //     // {
            //     //     id: 1002,
            //     //     label: '2017Q4会销套餐'
            //     // }, 
            //     {
            //         id: 1009,
            //         label: '2018Q1-D套餐'
            //     },
            //     // {
            //     //     id: 1011,
            //     //     label: '2018Q1-E套餐'
            //     // },

            //     //    {
            //     //     id: 1003,
            //     //     label: '会销套餐三'
            //     //  }
            // ],
            transportList: [], //寄送方式
            PayList: [], //支付方式
            PayTypes: [{
                "Id": 1,
                "ParmName": "支付宝"
            }, {
                "Id": 4,
                "ParmName": "微信"
            }, {
                "Id": 5,
                "ParmName": "pos机"
            }, ],
            SendMode: "",
            PayMode: "",
            form: this.getSubmitFormData(),
            SchoolConsigneeList: [],
            ConsigneeList: '', //收货地址
            ConsigneeListName: '', //联系人及电话
            UnitNum0: 1, //设备比
            UnitNum1: 60, //资源包数目比
            UnitNum2: 64, //英语正式课
            UnitNum3: 16, //培训课  已开班园所为8，未开班则8+1
            AddDialogVisible: false,
            showData: this.getShowData(), //弹窗传参
            PayTitle: "支付凭证单号",
            posShow: false,
            pageIndex: 1,
            pageSize: 10,
            load: false,
            minNum: 1,
            isOpen: false, //是否开班
            isDelShow: [false],
            payTypesArea: [],
            payList: [{}],
            addDialogVisiable: false //新增代理商

        }
    },
    methods: {
        getSubmitFormData() {
            return cloneDeep({
                "AgentId": 0, //代理商ID
                "SchoolId": 0, //园所ID
                "ClassNum": "", //班级数
                "PackageId": 1009, //套餐ID 
                "SchoolConsigneeId": 0, //园所收货地址ID
                "SendMode": 223, //寄送方式
                "PayMode": 222, //支付方式
                "GoodsList": [], //配套实物商品 
                "VirtualList": [], //配套虚拟商品
                "OrderPrice": 0, //订单价格
                "PayWay": "", //支付类型
                "Trade_No": '', //交易流水号
                "BankName": '', //银行名称
                "ExistMeetOrder": 0, //判断是否下单
                "ListMeetPay": []

            });
        },
        changeValue(val) {
            //会销套餐一、二是1倍增长，会销套餐三是3倍增长
            // 监听开通班级数改变价格 （订单价格=套餐单价*开通班级数）
            /* 
            套餐一：11000
            套餐二：14000
            套餐三：14000
            */
            if (val == 1009) {
                this.UnitPrice = 19800
                this.UnitNum1 = 60 //资源包
                this.UnitNum2 = 192
                this.UnitNum3 = 16
                this.ExperienceClassNum = 5
            } else if (val == 1002) {
                //  1002 套餐价格
                this.UnitPrice = 14000
                this.UnitNum1 = 60
                this.UnitNum2 = 64
                this.UnitNum3 = 16
                this.ExperienceClassNum = 5
            } else {
                // 1011套餐价格
                this.UnitPrice = 14000
                this.UnitNum1 = 60
                this.UnitNum2 = 64
                this.UnitNum3 = 16
                this.ExperienceClassNum = 3
            }

        },
        addFn() {
            this.payList.push({})
            this.isDelShow.push(true)
        },
        delPayFn(item) {
            this.payList.splice((item.index - 1), 1);

        },
        // 获取组件chooseDialog 值
        getDialogList(item) {
            if (item.title == '选择代理商') {
                this.agent = item.Customer + '   ' + item.Address + '   ' + item.AgentTel
                this.form.AgentId = item.Id,
                    this.school = '',
                    this.form.SchoolId = '',
                    this.ConsigneeList = '',
                    this.ConsigneeListName = ''

            } else {
                this.school = item.SchoolName + '   ' + item.PrincipalName + '   ' + item.PhoneNo
                this.form.SchoolId = item.Id
                this.getSchoolConsigneeList(this.form.SchoolId) //点击园所之后获取默认收货地址
                this.getCheckMeetOrder(this.form.SchoolId) //判断是否下过会销订单
            }
        },
        //获取选择弹窗收货地址
        getAddress(item) {
            this.ConsigneeList = item.ConsigneeProvinceName + '  ' + item.ConsigneeCityName + '  ' + item.ConsigneeAreaName + '  ' + item.ConsigneeAdress
            this.ConsigneeListName = item.Consignee + '  ' + item.ConsigneeTel
            this.form.SchoolConsigneeId = item.Id
        },
        // 选择代理商
        chooseAgent() {
            this.$refs.chooseDialog.show({
                title: '选择代理商'
            });
        },
        addAgentFn() {
            this.addDialogVisiable = true
        },
        //选择园所
        chooseSchool() {
            if (this.form.AgentId == 0) {
                this.$notify({
                    title: '警告',
                    message: '请先选择代理商',
                    type: 'warning'
                });
            } else {
                this.$refs.chooseDialog.show({
                    title: '选择园所',
                    AgentId: this.form.AgentId
                });

            }

        },
        //选择园所收货地址
        changeAddress() {
            if (this.form.SchoolId == 0) {
                this.$notify({
                    title: '警告',
                    message: '请先选择园所',
                    type: 'warning'
                });
            } else {
                this.$refs.AddressDialog.show({
                    //addressList:this.SchoolConsigneeList,
                    SchoolId: this.form.SchoolId
                });
            }

        },
        //添加幼儿园
        addSchool() {
            if (this.form.AgentId == 0) {
                this.$notify({
                    title: '警告',
                    message: '请先选择代理商',
                    type: 'warning'
                });
            } else {
                this.$refs.refoptOpenClassDialog.show({
                    AgentId: this.form.AgentId,
                    isAdd: true,
                    SchoolCome: 5,
                    isShowImg: false
                })
            }
        },
        getSchoolName(item) {
            //添加幼儿园后默认选中当前添加的幼儿园
            //item.SyncSchoolId存在则显示同步幼儿园后数据
            console.log(item)
            this.school = item.SchoolName + '  ' + item.PrincipalName + '  ' + item.PhoneNo
            this.form.SchoolId = item.SchoolId
            this.getSchoolConsigneeList(this.form.SchoolId)
            this.getCheckMeetOrder(this.form.SchoolId) //判断是否下过会销订单

        },
        //新增代理商后默认显示新增的那条数据
        getAgent(item) {
            //console.log(item)
            this.form.AgentId = item.AgentId
            this.getAgentList(item.AgentId)

        },
        getShowData() {
            return cloneDeep({
                OrderId: 0,
                title: '',
                isReadOnly: false
            });
        },
        initData() {
            // 初始化数据
            this.form = this.getSubmitFormData()
            this.isOpen = false
            this.agent = ''
            this.school = ''
            this.ConsigneeList = '' //收货地址
            this.ConsigneeListName = '' //联系人及电话
            this.payList = [{}]
            this.isDelShow = [false]
            this.showData = this.getShowData()

        },
        show(options) {
            this.initData() //初始化数据

            this.showData.title = options.title
            this.showData.isReadOnly = options.isReadOnly //true 为查看
            this.AddDialogVisible = true;
            if (this.showData.title !== '新增会销订单') {
                // 查看修改
                this.showData.OrderId = options.OrderId
                this.getList() //获取单条数据 
            }

        },
        submit() {
            this.form.OrderPrice = this.price;
            //"GoodsList": [],//配套实物商品 
            this.form.GoodsList = [],
                this.form.VirtualList = [],
                this.form.ListMeetPay = []
            for (let i = 0; i < this.tableData.length; i++) {
                this.form.GoodsList.push({
                    "ProId": this.tableData[i].proId,
                    "ProNum": this.tableData[i].proNum //本期数
                })
            }
            //"VirtualList": [],//配套虚拟商品
            for (let i = 0; i < this.tableData2.length; i++) {
                this.form.VirtualList.push({
                    "ProId": this.tableData2[i].proId,
                    "ProNum": this.tableData2[i].proNum // 本期数
                })
            }
            for (let i = 0; i < this.payList.length; i++) {
                let data = this.$refs['payInfo' + (i + 1)][0].validate();
                if (!data) {
                    return;
                }
                this.form.ListMeetPay.push(data);
            }
            console.log(this.form)
            // 判断
            let rule = [{
                name: "代理商",
                value: this.agent,
                required: true,
            }, {
                name: "园所",
                value: this.school,
                required: true,
            }, {
                name: "套餐",
                value: this.form.PackageId,
                required: true,
            }]
            var flag = util.checkForm({
                ele: this,
                rules: rule
            });

            if (!flag) {
                return;
            }
            if (this.showData.title == "修改订单") {
                if (this.form.PayWay !== 5) {
                    this.form.BankName = '';
                }
                this.getUpdateOrderList() //修改订单
            } else {
                this.getAddOrderList(); //新增订单
            }

        }
    },
    computed: {
        options() {
            // $route.path == '/Order/MeetOrder2' 用于下2017Q4会销订单
            if (this.$route.path == '/Order/MeetOrder2') {
                return [{
                        id: 1002,
                        label: '2017Q4会销套餐'
                    },
                    {
                        id: 1009,
                        label: '2018Q1-D套餐'
                    },
                ]
            }
            return [{
                id: 1009,
                label: '2018Q1-D套餐'
            }]

        },
        //订单价格
        price: function () {
            if (this.form.PackageId !== '') {
                return this.form.ClassNum * this.UnitPrice
            }
            return 0

        },
        // 新增虚拟商品本期数（套餐一时，商品数量全数发放，其余商品数量一半发放） 
        // 新增2018Q1-D套餐1009，全部发放
        currentPrice: function () {
            if (this.form.PackageId == 1009) {
                return this.form.ClassNum * this.UnitNum2
            } else {
                return this.form.ClassNum * this.UnitNum2 / 2
            }
        },
        // // 新增实物商品本期数（套餐一时，商品数量全数发放，其余商品数量一半发放）
        // 新增2018Q1-D套餐1009，全部发放
        currentPrice1: function () {
            if (this.form.PackageId == 1009) {
                return this.form.ClassNum * this.UnitNum1
            } else {
                return this.form.ClassNum * this.UnitNum1 / 2
            }
        },
        tableData: function () {
            if (this.form.PackageId !== '') {
                if (this.form.PackageId == 1011) {
                    // E 套餐55寸
                    return [{
                        'proId': 333,
                        'proName': '55寸在线教育平台终端',
                        "proNum": this.form.ClassNum,
                        "proNum2": this.form.ClassNum,
                        "proNum1": this.form.ClassNum
                    }, {
                        'proId': 639,
                        'proName': '英语幼儿操作材料包',
                        "proNum": this.form.ClassNum * this.UnitNum1,
                        "proNum2": this.currentPrice1,
                        "proNum1": 0
                    }]

                } else {
                    return [{
                        'proId': 320,
                        'proName': '65寸在线教育平台终端',
                        "proNum": this.form.ClassNum,
                        "proNum2": this.form.ClassNum,
                        "proNum1": this.form.ClassNum
                    }, {
                        'proId': 639,
                        'proName': '英语幼儿操作材料包',
                        "proNum": this.form.ClassNum * this.UnitNum1,
                        "proNum2": this.currentPrice1,
                        "proNum1": 0
                    }]
                }

            }
            return []

        },
        tableData2: function () {
            if (this.form.PackageId !== '') {
                if (this.isOpen) {
                    // 首次下单赠送5节体验课
                    //var Unitnum = this.form.ClassNum * this.UnitNum3 + 1
                    // 新增虚拟商品本期数（套餐一1001时，商品数量全数发放，其余商品数量一半发放） 
                    //var currentPrice2 = this.form.ClassNum * this.UnitNum3 / 2 + 1


                    if (this.form.PackageId == 1009) {
                        // 新增2018Q1-D套餐1009，全部发放
                        // 以下新修改规则（冰冰2018/02/27）
                        //修改 培训课首单是16+开班数   非首单是开班数     
                        //本期数 体验课固定 5*开班数
                        //虚拟商品本期数 （套餐一1001时，商品数量全数发放，其余商品数量一半发放）+开班数
                        let Unitnum = 16 + this.form.ClassNum
                        let currentPrice2 = 8 + this.form.ClassNum
                        return [{
                            'proId': 640,
                            'proName': '英语正式课',
                            "proNum": this.form.ClassNum * this.UnitNum2,
                            "proNum2": this.currentPrice
                        }, {
                            'proId': 641,
                            'proName': '培训课',
                            "proNum": Unitnum,
                            "proNum2": currentPrice2
                        }, {
                            'proId': 646,
                            'proName': '体验课',
                            "proNum": this.ExperienceClassNum * this.form.ClassNum,
                            "proNum2": this.ExperienceClassNum * this.form.ClassNum
                        }]
                    } else {
                        let Unitnum = this.form.ClassNum * this.UnitNum3 + 1
                        let currentPrice2 = this.form.ClassNum * this.UnitNum3 / 2 + 1
                        return [{
                            'proId': 640,
                            'proName': '英语正式课',
                            "proNum": this.form.ClassNum * this.UnitNum2,
                            "proNum2": this.currentPrice
                        }, {
                            'proId': 641,
                            'proName': '培训课',
                            "proNum": Unitnum,
                            "proNum2": currentPrice2
                        }, {
                            'proId': 646,
                            'proName': '体验课',
                            "proNum": this.ExperienceClassNum,
                            "proNum2": this.ExperienceClassNum
                        }]
                    }

                } else {
                    if (this.form.PackageId == 1009) {
                        // 新增2018Q1-D套餐1009，全部发放
                        // 以下新修改规则（冰冰2018/02/27）
                        //修改 培训课首单是16+开班数   非首单是开班数     
                        //本期数 体验课固定 5*开班数
                        //虚拟商品本期数 （套餐一1001时，商品数量全数发放，其余商品数量一半发放）+开班数

                        return [{
                            'proId': 640,
                            'proName': '英语正式课',
                            "proNum": this.form.ClassNum * this.UnitNum2,
                            "proNum2": this.currentPrice
                        }, {
                            'proId': 641,
                            'proName': '培训课',
                            "proNum": this.form.ClassNum,
                            "proNum2": this.form.ClassNum
                        }, {
                            'proId': 646,
                            'proName': '体验课',
                            "proNum": this.ExperienceClassNum * this.form.ClassNum,
                            "proNum2": this.ExperienceClassNum * this.form.ClassNum
                        }]
                    }
                    var Unitnum = this.form.ClassNum * this.UnitNum3
                    var currentPrice2 = Unitnum / 2
                    return [{
                        'proId': 640,
                        'proName': '英语正式课',
                        "proNum": this.form.ClassNum * this.UnitNum2,
                        "proNum2": this.currentPrice
                    }, {
                        'proId': 641,
                        'proName': '培训课',
                        "proNum": Unitnum,
                        "proNum2": currentPrice2
                    }]

                }
            }
            return []


        },
    },
}


// WEBPACK FOOTER //
// ./src/pages/Order/MeetOrder/addSellingOrder/vm.js